export default class {
  constructor() {
    this.attach()
  }

  attach() {
    const scrollToTopButton = document.getElementById('scrollToTop')

    if (scrollToTopButton) {
      window.addEventListener('scroll', () => {
        if (window.scrollY > window.innerHeight / 2) {
          scrollToTopButton.style.display = 'flex'
        } else {
          scrollToTopButton.style.display = 'none'
        }
      })

      scrollToTopButton.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    }
  }
}
